<ul [id]="id + '-thesaurus-concept-list'" class="sh-tag-list sh-form-tag-list__list">
  @if (multiple) {
    @for (tag of (tags$ | async)?.options; track tag; let i = $index) {
      <li
        [id]="id + '-thesaurus-concept-list-tag-' + i"
        class="sh-tag sh-tag-list__item -sh-truncate"
        [title]="tag.label"
        [class.sh-tag--readonly]="disabled"
        >
        <span class="sh-tag__label">{{ tag.label }}</span>
        @if (!disabled) {
          <button
            #tagItem
            [tabindex]="i === 0 ? 0 : -1"
            [id]="id + '-thesaurus-concept-list-tag-' + i + '-remove-action'"
            type="button"
            class="sh-tag__button"
            (click)="removeValue(tag.value)"
            (keyup.delete)="removeValue(tag.value)"
            (keyup.backspace)="removeValue(tag.value)"
            (keydown.space)="preventDefault($event)"
            (keydown.enter)="preventDefault($event)"
            (focus)="onFocus()"
            >
            <svg sh-icon [name]="'delete'" [size]="sizes.SMALL" [addDefaultClasses]="false" aria-hidden="true" class="sh-tag__icon"></svg>
          </button>
        }
      </li>
    }
  }
  @for (tag of suggestions$ | async; let i = $index; track i) {
    @if (removableSuggestions) {
      <li
        [id]="id + '-thesaurus-suggestion-tag-' + i"
        class="sh-tag sh-tag-list__item -sh-truncate"
        [title]="('thesaurus.suggested-concept' | translate) + ': ' + tag"
        [class.sh-tag--readonly]="true"
        >
        <span class="sh-tag__label">{{ tag }}</span>
        @if (!disabled) {
          <button
            #tagItem
            [tabindex]="(tags$ | async)?.options.length || i !== 0 ? -1 : 0"
            [id]="id + '-thesaurus-concept-list-tag-' + i + '-remove-action'"
            type="button"
            class="sh-tag__button"
            (click)="removeSuggestion(tag)"
            (keyup.delete)="removeSuggestion(tag)"
            (keyup.backspace)="removeSuggestion(tag)"
            (keydown.enter)="preventDefault($event)"
            (keydown.space)="preventDefault($event)"
            (focus)="onFocus()"
            >
            <svg sh-icon [name]="'delete'" [size]="sizes.SMALL" [addDefaultClasses]="false" aria-hidden="true" class="sh-tag__icon"></svg>
          </button>
        }
      </li>
    } @else {
      <li
        [id]="id + '-thesaurus-suggestion-tag-' + i"
        class="sh-tag sh-tag-list__item -sh-truncate"
        [title]="('thesaurus.suggested-concept' | translate) + ': ' + tag"
        [class.sh-tag--readonly]="true"
        >
        <span class="sh-tag__label">{{ tag }}</span>
      </li>
    }
  }
</ul>
